// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f7338e22","787":"e6af2907","936":"ca3a5532"}[chunkId] + ".chunk.js";
};